<template>
    <div class="te-payment-methods" :class="{ 'te-required': method === null }">
        <div class="te-cart-heading">{{languageSettings.paymentMethod}}</div>
        <ul class="te-payment-methods-list">
            <li class="te-payment-method"
                :class="[method === 'ideal' ? 'active' : '']"
                @click="selectMethod('ideal')"
            >
                <span class="te-payment-method__icon"><img src="https://mollie.com/external/icons/payment-methods/ideal.svg"></span>
                <span class="te-payment-method__label">iDeal</span>
            </li>
            <li class="te-payment-method"
                :class="[method === 'creditcard' ? 'active' : '']"
                @click="selectMethod('creditcard')"
            >
                <span class="te-payment-method__icon"><img src="https://mollie.com/external/icons/payment-methods/creditcard.svg"></span>
                <span class="te-payment-method__label">Credit card</span>
            </li>
        </ul>
        <p v-if="method === null" class="te-payment-method-message">{{languageSettings.paymentMethodRequired}}</p>
    </div>
</template>

<script>
    export default {
        name: "PaymentMethod",

        data() {
            return {
                method: null,
            };
        },

        props: {
            language: {
                type: Object
            },
        },

        computed: {
            languageSettings: function() {
                const defaultSettings = {
                    paymentMethod: 'Payment method',
                    paymentMethodRequired: '',
                };
                return Object.assign(defaultSettings, this.language);
            },
        },

        methods: {
            selectMethod(method) {
                this.method = method;
                this.$emit('change', this.method);
            },
        }
    }
</script>

<style scoped>

</style>
